const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/users/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { USER_SORT_KEYS } from '@/features/users/model/user-columns';
import { createSearchValidator } from '@/lib/search-validators';
type UserFilters = {
  states?: string;
  groupIds?: string;
};
const FILTER_KEYS: (keyof UserFilters)[] = ['states', 'groupIds'];
export const Route = createFileRoute('/_app/users/')({
  validateSearch: createSearchValidator<UserFilters, string>({
    tabs: [],
    filterKeys: FILTER_KEYS,
    sortKeys: USER_SORT_KEYS
  }),
  staticData: {
    breadCrumb: 'Users'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/** Mirrors drivers' own `splitMultiValue` — the URL keeps a multiselect comma-joined. */